export default "__VITE_ASSET__gehufENu__"